import React from 'react';
import * as Sentry from '@sentry/react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }

  componentDidCatch(error, info) {
    this.setState({
      hasError: true
    });

    Sentry.withScope(scope => {
      scope.setTag('location', this.props.location);
      scope.setExtra('message', 'An error has occurred in an ErrorBoundary');
      scope.setExtra('info', info);
    });
    Sentry.captureException(error);
  }

  render() {
    if (this.state.hasError) {
      return <div className="error-holder">{this.props.errorComponent}</div>;
    }
    return this.props.children;
  }
}

ErrorBoundary.defaultProps = {
  location: 'unknown',
  errorComponent: <h1>Error: Something went wrong.</h1>
};

export default ErrorBoundary;
